import { Glass, Dot, PillChip, DisplayText, BodyText } from "../../components/mobile/primitives";

function JourneyTrackerRecommendScreen() {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      {/* Header */}
      <div
        style={{
          padding: "8px 16px 6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexShrink: 0,
        }}
      >
        <DisplayText size={18}>Kin</DisplayText>
        <PillChip active color="var(--color-kin-lavender)">
          Sleep Deep Dive
        </PillChip>
      </div>

      {/* Messages */}
      <div
        style={{
          flex: 1,
          padding: "0 12px",
          display: "flex",
          flexDirection: "column",
          gap: 7,
          overflowY: "hidden",
        }}
      >
        {/* Prior context — compact */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div
            style={{
              maxWidth: "72%",
              background: "rgba(254,253,251,0.82)",
              border: "1px solid rgba(255,255,255,0.52)",
              borderRadius: "20px 20px 6px 20px",
              padding: "10px 14px",
            }}
          >
            <BodyText size={10} color="var(--color-kin-black)">
              My afternoons still crash. What should I track next?
            </BodyText>
          </div>
        </div>

        {/* AI response */}
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <div
            style={{
              maxWidth: "90%",
              background: "linear-gradient(135deg, rgba(165,144,255,0.11), rgba(165,144,255,0.05))",
              border: "1px solid rgba(165,144,255,0.20)",
              borderRadius: "6px 20px 20px 20px",
              padding: "12px 14px",
            }}
          >
            <BodyText
              size={10}
              color="var(--color-kin-black)"
              weight={500}
              style={{ lineHeight: 1.5 }}
            >
              Log meal timing and caffeine for 7 days. It's about 30 seconds per meal, and it will
              let me test if those inputs explain your afternoon dips.
            </BodyText>

            {/* Tracker card */}
            <div
              style={{
                background: "rgba(255,255,255,0.75)",
                border: "1px solid rgba(255,208,40,0.30)",
                borderRadius: 12,
                padding: "12px 14px",
                marginTop: 8,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <div
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: 8,
                  background: "rgba(255,208,40,0.14)",
                  border: "1px solid rgba(255,208,40,0.30)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Dot color="var(--color-kin-gold)" size={8} />
              </div>
              <div style={{ flex: 1 }}>
                <BodyText size={10} weight={700}>
                  Diet + Caffeine Tracker
                </BodyText>
                <BodyText size={8} color="var(--color-kin-muted)" weight={400}>
                  3 quick logs/day · 30 sec each
                </BodyText>
              </div>
              <div
                style={{
                  background: "var(--color-kin-gold)",
                  borderRadius: 20,
                  padding: "5px 12px",
                  flexShrink: 0,
                }}
              >
                <BodyText size={8} color="var(--color-kin-black)" weight={700}>
                  Set up
                </BodyText>
              </div>
            </div>
          </div>
        </div>

        {/* AI follow-up */}
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <div
            style={{
              maxWidth: "85%",
              background: "linear-gradient(135deg, rgba(165,144,255,0.11), rgba(165,144,255,0.05))",
              border: "1px solid rgba(165,144,255,0.20)",
              borderRadius: "6px 20px 20px 20px",
              padding: "12px 14px",
            }}
          >
            <BodyText
              size={10}
              color="var(--color-kin-black)"
              weight={500}
              style={{ lineHeight: 1.5 }}
            >
              After 7 days, I'll score confidence and give targeted changes for energy timing,
              caffeine cut-off, and meal composition.
            </BodyText>
          </div>
        </div>
      </div>

      {/* Input */}
      <div style={{ padding: "6px 12px 0", flexShrink: 0 }}>
        <Glass
          style={{
            padding: "8px 10px 8px 16px",
            display: "flex",
            alignItems: "center",
            gap: 8,
            borderRadius: 28,
          }}
        >
          <BodyText size={10} color="var(--color-kin-muted)" weight={500}>
            Ask about your health…
          </BodyText>
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: "50%",
              background: "var(--color-kin-green-soft)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              marginLeft: "auto",
            }}
          >
            <span style={{ color: "#fff", fontSize: 13, fontWeight: 700, lineHeight: 1 }}>↑</span>
          </div>
        </Glass>
      </div>
    </div>
  );
}

export { JourneyTrackerRecommendScreen };
